module.exports = __webpack_public_path__ + "img/SL-M-160-230.8b71b903.svg";